export const shanghaiAbout =
  'Tickle your senses and enjoy the magic of the Far East in an inviting and relaxing atmosphere that will make you drift away to the other side of the world. With\n' +
  'over a quarter-century long tradition, Shanghai restaurant will provide you with a variety of Chinese dishes as well as the best sushi in town. Garnished dishes, prepared with original ingredients by Chinese chefs, who will take you into the spectacular world of extraordinary Asian cuisine and culture with their specialties. To make your experience more exquisite we suggest you to try homemade Chinese rakija, Sake wine or Japanese beer.';
export const lavillaAbout =
  'The warmth of sand and sea shore freshness, gentle sunny days and pleasant breeze embrace LaVilla Restaurant gloving the Mediterranean style in all its glory. Thanks to it LaVilla restaurant experience will take you to an unforgettable culinary journey with the professional service of the staff. You can find a wide range of dishes on the menu. With suggestions of our staff, make the right choice and enjoy the tastes that will awaken all your senses. From first-class seafood, Italian specialties and top quality meat prepared with the great dedication of experienced chefs, LaVilla will leave even the pickiest eaters breathless.';
export const abstract =
  'Tucked between the walls of the centuries Old Town, with breathtaking views of the marina, there are two restaurants that offer comfort and extraordinary gastronomic pleasure. Our restaurants are ideal places for romantic dinners, family gatherings and quality time spent with your friends in a relaxing atmosphere. It is up to you whether to give in to the tastes of traditional Mediterranean cuisine at LaVilla restaurant or to explore Asian cuisine, rich in flavor at the Shanghai restaurant.';

const restaurants = [
  {
    id: 'shanghai',
    name: 'Shanghai Restaurant',
    background: require('../../../assets/images/food/shanghai/shanghai1.jpeg'),
    about: shanghaiAbout,
    abstract: abstract,
    title: 'Shanghai Restaurant',
    subtitle: 'Chinese & Sushi Cuisine',
    logoMain: require('../../../assets/images/shanghaiLogoSec.png'),
    logo: require('../../../assets/images/shanghaiLogo.png'),
    color: '#0d4255c4',
    gallery: [
      require('../../../assets/images/food/shanghai/shanghai1.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai2.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai3.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai4.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai5.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai6.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai7.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai8.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai9.jpeg'),
    ],
  },
  {
    id: 'lavilla',
    name: 'LaVilla Restaurant',
    background: require('../../../assets/images/food/lavilla/lavilla1.jpeg'),
    about: lavillaAbout,
    abstract: abstract,
    title: 'LaVilla Restaurant',
    subtitle: 'Mediterranean Cuisine',
    logoMain: require('../../../assets/images/laVillaLogoSec.png'),
    logo: require('../../../assets/images/laVillaLogo.png'),
    color: '#0d4255c4',
    gallery: [
      require('../../../assets/images/food/lavilla/lavilla1.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla2.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla3.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla4.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla5.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla6.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla7.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla8.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla9.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla10.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla11.jpeg'),
    ],
  },
];

export default restaurants;